export default function InputPspElement() {
    return {
        restrict: "E",
        scope: {
            form: "=",
            model: "=",
            validation: "=",
            label: "=",
        },
        template: require("./template.html"),
        controller: function ($scope, Users) {
            $scope.validatePSP = () => {
                // Reset validation
                $scope.form.pspElement.serverMessage = "";
                $scope.form.pspElement.$setValidity("isValid", false);
                if (
                    $scope.model.pspElement &&
                    $scope.model.pspElement.length == 19
                ) {
                    var PSPRegex = /[a-zA-Z]{2}\-\d{10}\-\d{5}$/;
                    if (PSPRegex.test($scope.model.pspElement)) {
                        Users.validatePSP($scope.model.pspElement)
                            .then((response) => {
                                if (response.isValid) {
                                    $scope.form.pspElement.serverMessage =
                                        "Gyldigt PSP";
                                    $scope.form.pspElement.$setValidity(
                                        "isValid",
                                        true
                                    );
                                } else {
                                    $scope.form.pspElement.serverMessage =
                                        "Ugyldigt PSP";
                                    $scope.form.pspElement.$setValidity(
                                        "isValid",
                                        false
                                    );
                                }
                            })
                            .catch(() => {});
                    } else {
                        $scope.form.pspElement.serverMessage = "Ugyldigt PSP";
                        $scope.form.pspElement.$setValidity("isValid", false);
                    }
                }
            };
        },
    };
}
